export default __webpack_public_path__ + "static/media/11.adf8c9f2.webp";